import api from "../api";

export class ReportService {

    static fetchReport(code) {return api.get(`reports/${code}`)}
    static downloadReport(code, format) {
        return api.get(`reports/${code}?format=${format}`, {
            responseType: 'arraybuffer',
            timeout: 30000,
        })
    }
    static fetchReportList() {return api.get(`reports/list`)}

    static createFinalReport(project, locality) {
        return api.get(`reports/docs?project_id=${project}&locality_id=${locality}`, {
            //responseType: 'arraybuffer',
            timeout: 30000,
        })
    }

    static downloadFinalReport(project, locality) {
        return api.get(`reports/docs-download?project_id=${project}&locality_id=${locality}`, {
            responseType: 'arraybuffer',
            timeout: 30000,
        })
    }
}
